import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo">NV<span>.</span></div>
        <p className="footer-copy">Designed & built by Nikhil Vinchurkar · {new Date().getFullYear()}</p>
        <div className="footer-links">
          <a href="https://github.com/Nikhil-Vin" target="_blank" rel="noreferrer">GitHub</a>
          <a href="https://linkedin.com/in/nikhil-vinchurkar0667" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="mailto:nikhilvinchurkar070@gmail.com">Email</a>
        </div>
      </div>
    </footer>
  );
}
